import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Form, Button, Row, Col } from 'antd';
import { FormItems } from './componentsMobileForm/FormItems';
import { ButtonFinish } from './styles';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { useNotifications } from '../../hooks/useNotifications';

const MobileForm = ({
  fields = [],
  onSaveDraft,
  onFinish,
  showFinishButton,
  tabKey,
  formValues,
  onChange,
  isDraftEnabled,
  disabled,
  disableFinish,
  confirmFinish = false,
  fieldsErrors,
  finishText = 'finish',
}) => {
  const { translate: t } = useDictionaryTranslation();
  const [form] = Form.useForm();
  const { showConfirmNotification } = useNotifications();

  const handleSaveDraft = () => {
    const values = form.getFieldsValue();
    onSaveDraft(tabKey, values);
  };

  const handleFinalize = () => {
    form.validateFields().then((values) => {
      onFinish(tabKey, values);
    });
  };

  const onConfirmFinish = () => {
    if (!confirmFinish) {
      handleFinalize();
      return;
    }
    showConfirmNotification({
      title: 'areYouSure',
      content: 'formWillBeFinish',
      onOk: () => {
        handleFinalize();
      },
    });
  };

  const onChangeFieldValue = (idInput, value) => {
    form.setFieldValue(idInput, value);
    onChange({ idInput, value });
  };

  useEffect(() => {
    form.setFieldsValue(formValues);
  }, [form, formValues]);

  useEffect(() => {
    if (!fieldsErrors?.length) return;
    const fieldsData = fieldsErrors.map((field) => ({
      name: field.idInput,
      errors: field.error?.message ? [t(field.error.message)] : [],
    }));
    form.setFields(fieldsData);
  }, [form, fieldsErrors]);

  return (
    <Form form={form} layout="vertical" onFinish={onConfirmFinish}>
      <FormItems formFields={fields} values={formValues} onChange={onChangeFieldValue} disabled={disabled} />
      <Row justify="end" gutter={20} style={{ marginTop: '20px' }}>
        {isDraftEnabled && (
          <Col>
            <Button htmlType="button" onClick={handleSaveDraft} style={{ background: '#5A5F7D', color: 'white' }}>
              {t('saveDraft')}
            </Button>
          </Col>
        )}
        {showFinishButton && (
          <Col>
            <ButtonFinish htmlType="submit" type="primary" disabled={disableFinish}>
              {t(finishText)}
            </ButtonFinish>
          </Col>
        )}
      </Row>
    </Form>
  );
};

MobileForm.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      value: PropTypes.any,
    }),
  ).isRequired,
  onSaveDraft: PropTypes.func,
  onFinish: PropTypes.func,
  formValues: PropTypes.object,
  fieldsErrors: PropTypes.arrayOf(
    PropTypes.shape({
      idInput: PropTypes.string.isRequired,
      error: PropTypes.string,
    })
  ),
  tabKey: PropTypes.number,
  onChange: PropTypes.func,
  showFinishButton: PropTypes.bool,
  isDraftEnabled: PropTypes.bool,
  disabled: PropTypes.bool,
  disableFinish: PropTypes.bool,
  confirmFinish: PropTypes.bool,
  finishText: PropTypes.string,
};

export default MobileForm;
